module.exports = __webpack_public_path__ + "img/09_question.3cf45605.png";